import repository from '@/utils/repository';

export default {
    searchBranchInfo: (data) => {
        return repository.post(`/move/postCommonBranchInfo`, {
            ...data
        });
    }
};
